<form [formGroup]="createConnectionForm" (ngSubmit)="createConnection()">
    <div>
        <mat-form-field class="w-100">
            <mat-label>Connection Name</mat-label>
            <input matInput type="text" formControlName="connectionAlias" />
            <mat-error *ngIf="hasFieldError('connectionAlias')"> Connection Name is required </mat-error>
        </mat-form-field>
        <mat-form-field class="w-100">
            <mat-label>Business Domain</mat-label>
            <mat-select formControlName="businessDomainId">
                @for (businessDomain of businessDomains$ | async; track businessDomain) {
                    <mat-option [value]="businessDomain.id">{{ businessDomain.name }}</mat-option>
                }
            </mat-select>
            <mat-error *ngIf="hasFieldError('businessDomainId')"> Business Domain is required </mat-error>
        </mat-form-field>

        <mat-form-field class="w-100">
            <mat-label>Connection Type</mat-label>
            <mat-select formControlName="connectionType">
                @for (connectionType of connectionTypes; track connectionType) {
                    <mat-option [value]="connectionType">{{ connectionType }}</mat-option>
                }
            </mat-select>
            <mat-error *ngIf="hasFieldError('connectionType')"> Connection Type is required </mat-error>
        </mat-form-field>

        <ng-container *ngIf="createConnectionForm.get('connectionType')?.value == 'DataLake'">
            <div style="display: flex; align-items: center; gap: 1rem; margin-bottom: 1rem">
                <mat-form-field style="flex: 1; min-width: 150px">
                    <mat-label>Storage Account Name</mat-label>
                    <mat-select formControlName="datalake">
                        @if (
                            createConnectionForm.get('datalake')?.value &&
                            !isKnownDatalakeStorageAccount(createConnectionForm.get('datalake')?.value)
                        ) {
                            <mat-option [value]="createConnectionForm.get('datalake')?.value">
                                {{ createConnectionForm.get('datalake')?.value }}
                            </mat-option>
                        }
                        @for (
                            datalakeStorageAccountOption of datalakeStorageAccountOptions;
                            track datalakeStorageAccountOption
                        ) {
                            <mat-option [value]="datalakeStorageAccountOption">
                                {{ datalakeStorageAccountOption }}
                            </mat-option>
                        }
                    </mat-select>
                    <!-- <input matInput type="text" formControlName="datalake" placeholder="e.g., chevrondatalake" /> -->
                    <mat-error *ngIf="createConnectionForm.get('datalake')?.hasError('required')">
                        Storage account name is required
                    </mat-error>
                    <mat-error *ngIf="createConnectionForm.get('datalake')?.hasError('invalidStorageAccount')">
                        Must be 3-24 characters, lowercase letters and digits only
                    </mat-error>
                </mat-form-field>

                <mat-form-field style="flex: 1; min-width: 150px">
                    <mat-label>Container Name</mat-label>
                    <mat-select formControlName="container">
                        @if (
                            createConnectionForm.get('container')?.value &&
                            !isKnownDatalakeContainer(createConnectionForm.get('container')?.value)
                        ) {
                            <mat-option [value]="createConnectionForm.get('container')?.value">
                                {{ createConnectionForm.get('container')?.value }}
                            </mat-option>
                        }
                        @for (datalakeContainerOption of datalakeContainerOptions; track datalakeContainerOption) {
                            <mat-option [value]="datalakeContainerOption">
                                {{ datalakeContainerOption }}
                            </mat-option>
                        }
                    </mat-select>
                    <!-- <input matInput type="text" formControlName="container" placeholder="e.g., raw/refined/produced" /> -->
                    <mat-error *ngIf="createConnectionForm.get('container')?.hasError('required')">
                        Container is required
                    </mat-error>
                    <mat-error *ngIf="createConnectionForm.get('container')?.hasError('invalidContainerName')">
                        Must be 3-63 characters, lowercase letters, digits and hyphens only.
                    </mat-error>
                </mat-form-field>

                <mat-form-field style="flex: 1; min-width: 200px">
                    <mat-label>DFS Domain</mat-label>
                    <input matInput type="text" formControlName="dfsDomain" placeholder="e.g., dfs.core.windows.net" />
                    <mat-error *ngIf="createConnectionForm.get('dfsDomain')?.hasError('required')">
                        DFS Domain is required
                    </mat-error>
                    <mat-error *ngIf="createConnectionForm.get('dfsDomain')?.hasError('invalidDfsDomain')">
                        Invalid domain format
                    </mat-error>
                </mat-form-field>
            </div>
        </ng-container>

        <ng-container
            *ngIf="
                createConnectionForm.get('connectionType')?.value === 'SQLServer' ||
                createConnectionForm.get('connectionType')?.value === 'Databricks'
            "
        >
            <mat-form-field class="w-100">
                <mat-label>Connection Auth Type</mat-label>
                <mat-select formControlName="connectionAuthType">
                    @for (
                        connectionAuthTypeOption of connectionAuthTypeOptions$ | async;
                        track connectionAuthTypeOption.connectionAuthType
                    ) {
                        <mat-option
                            [value]="connectionAuthTypeOption.connectionAuthType"
                            [disabled]="connectionAuthTypeOption.disabled"
                        >
                            {{ connectionAuthTypeOption.connectionAuthType }}
                        </mat-option>
                    }
                </mat-select>
                <mat-error *ngIf="hasFieldError('connectionAuthType')"> Connection Auth Type is required </mat-error>
            </mat-form-field>
        </ng-container>

        <ng-container
            *ngIf="
                createConnectionForm.get('connectionType')?.value === 'SQLServer' ||
                createConnectionForm.get('connectionType')?.value === 'Databricks'
            "
        >
            <mat-form-field class="w-100">
                <mat-label>{{
                    createConnectionForm.get('connectionType')?.value === 'Databricks' ? 'JDBC URL' : 'Host'
                }}</mat-label>
                <input
                    matInput
                    type="text"
                    formControlName="host"
                    [placeholder]="
                        createConnectionForm.get('connectionType')?.value === 'Databricks'
                            ? 'jdbc:databricks://\${host}:\${port}/default;transportMode=http;HttpPath=\${clusterHttpPath};AuthMech=3;'
                            : ''
                    "
                />
                <mat-error *ngIf="hasFieldError('host')">
                    {{ createConnectionForm.get('connectionType')?.value === 'Databricks' ? 'JDBC URL' : 'Host' }} is
                    required
                </mat-error>
                <mat-error *ngIf="createConnectionForm.get('host')?.hasError('credentialsInUrl')">
                    Credentials detected in URL. Please remove PWD/password from the JDBC URL and enter them in the
                    Password field.
                </mat-error>
            </mat-form-field>

            <mat-form-field class="w-100">
                <mat-label>Username</mat-label>
                <input
                    matInput
                    type="text"
                    formControlName="username"
                    [readonly]="
                        createConnectionForm.get('connectionType')?.value === 'Databricks' &&
                        createConnectionForm.get('connectionAuthType')?.value === 'UsernamePass'
                    "
                />
                <mat-error *ngIf="hasFieldError('username')"> Username is required </mat-error>
            </mat-form-field>

            <mat-form-field *ngIf="showInputForSQLPassword()" class="w-100">
                <mat-label>Password</mat-label>
                <input matInput [type]="hideSQLPassword() ? 'password' : 'text'" formControlName="password" />
                <mat-error *ngIf="hasFieldError('password')"> Password is required </mat-error>
            </mat-form-field>

            <mat-form-field *ngIf="createConnectionForm.get('connectionType')?.value === 'SQLServer'" class="w-100">
                <mat-label>Database Name</mat-label>
                <input matInput type="text" formControlName="databaseName" />
                <mat-error *ngIf="hasFieldError('databaseName')"> Database Name is required </mat-error>
            </mat-form-field>

            <mat-form-field class="w-100">
                <mat-label>Port</mat-label>
                <input matInput type="number" formControlName="port" />
                <mat-error *ngIf="hasFieldError('port')"> Port is required </mat-error>
            </mat-form-field>

            <mat-form-field
                *ngIf="
                    createConnectionForm.get('connectionType')?.value === 'Databricks' &&
                    createConnectionForm.get('isUnityCatalog')?.value
                "
                class="w-100"
            >
                <mat-label>Catalog</mat-label>
                <input matInput type="text" formControlName="catalog" />
                <mat-error *ngIf="hasFieldError('catalog')"> Catalog is required </mat-error>
            </mat-form-field>

            <div style="display: flex; align-items: center; gap: 2rem">
                <mat-slide-toggle formControlName="isPushdown"> Is pushdown </mat-slide-toggle>
                <mat-slide-toggle
                    *ngIf="createConnectionForm.get('connectionType')?.value === 'Databricks'"
                    formControlName="isUnityCatalog"
                >
                    Is Unity Catalog
                </mat-slide-toggle>
            </div>
        </ng-container>

        <mat-accordion *ngIf="showInputForClientSecret()">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>Advanced Options</mat-panel-title>
                </mat-expansion-panel-header>

                <div style="display: flex; flex-direction: column; gap: 16px; padding: 8px">
                    <mat-slide-toggle formControlName="useBringYourOwnSP"> Use Your Own Credentials </mat-slide-toggle>

                    <mat-form-field appearance="fill">
                        <mat-label>Client Id</mat-label>
                        <input matInput type="text" formControlName="clientId" />
                        <mat-error *ngIf="hasFieldError('clientId')"> Client Id is required </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="fill">
                        <mat-label>Client Secret</mat-label>
                        <input
                            matInput
                            [type]="hideClientSecret() ? 'password' : 'text'"
                            formControlName="clientSecret"
                        />

                        <mat-error *ngIf="hasFieldError('clientSecret')"> Client Secret is required </mat-error>
                    </mat-form-field>
                </div>
            </mat-expansion-panel>
        </mat-accordion>

        <div style="display: flex; justify-content: flex-end; gap: 1rem; margin-top: 1rem; margin-bottom: 1rem">
            <button
                mat-flat-button
                type="button"
                (click)="createConnection()"
                [disabled]="!createConnectionForm.valid || isCreatingConnection()"
            >
                Create connection
            </button>
            <mat-progress-spinner *ngIf="isCreatingConnection()" mode="indeterminate" diameter="30" color="primary">
            </mat-progress-spinner>
        </div>
    </div>
</form>
